import { h, Host } from "@stencil/core";
/** A pill display of an number, that pulses on change. Caps out at 999. */
export class Counter {
  constructor() {
    this.count = 0;
    this.size = 24;
    this.variant = 'filled';
    this.color = undefined;
    this.pulsing = false;
  }
  disconnectCallback() {
    clearTimeout(this.timeout);
  }
  pulse() {
    this.pulsing = true;
    this.timeout = setTimeout(() => (this.pulsing = false), 300);
  }
  render() {
    const height = this.size;
    const width = this.count > 999
      ? this.size * 2.2
      : this.count > 99
        ? this.size * 1.6
        : this.size;
    return (h(Host, { class: {
        pulse: this.pulsing,
        [this.color ?? '']: this.color !== null,
      } }, h("svg", { xmlns: 'http://www.w3.org/2000/svg', height: height, width: width }, h("rect", { x: 1, y: 1, width: width - 2, height: height - 2, rx: this.size / 2 }), h("text", { x: '50%', dy: '70%', "text-anchor": 'middle', style: { fontSize: `${this.size * 0.54}px` } }, this.count > 999 ? '999+' : `${this.count}`))));
  }
  static get is() { return "es-counter"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["es-counter.css"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["es-counter.css"]
    };
  }
  static get properties() {
    return {
      "count": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The number to display"
        },
        "attribute": "count",
        "reflect": false,
        "defaultValue": "0"
      },
      "size": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The height of the counter that the rest of the dimensions scale from"
        },
        "attribute": "size",
        "reflect": false,
        "defaultValue": "24"
      },
      "variant": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "CounterVariant",
          "resolved": "\"filled\" | \"minimal\" | \"outline\"",
          "references": {
            "CounterVariant": {
              "location": "import",
              "path": "./types",
              "id": "src/components/es-counter/types.ts::CounterVariant"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The display style of the counter."
        },
        "attribute": "variant",
        "reflect": true,
        "defaultValue": "'filled'"
      },
      "color": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "CounterColor",
          "resolved": "\"error\" | \"okay\" | \"warning\" | undefined",
          "references": {
            "CounterColor": {
              "location": "import",
              "path": "./types",
              "id": "src/components/es-counter/types.ts::CounterColor"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Choose the color variant of the counter"
        },
        "attribute": "color",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "pulsing": {}
    };
  }
  static get watchers() {
    return [{
        "propName": "count",
        "methodName": "pulse"
      }];
  }
}
//# sourceMappingURL=es-counter.js.map
